export default __webpack_public_path__ + "locales/pl/SharingPanel.json?hash=abf14f8c504ade1cfc58dc7a3e074bdc";